import { Component, inject, input } from "@angular/core";
import {
  NavBarService,
  SubItemMenu,
} from "@app/layouts/nav-bar/nav-bar.service";
import { NgClass } from "@angular/common";
import { SubListNavBarComponent } from "@app/layouts/nav-bar/sub-list-nav-bar/sub-list-nav-bar.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-popup-minimized-nav-bar",
  standalone: true,
  imports: [NgClass, SubListNavBarComponent, TranslateModule],
  templateUrl: "./popup-minimized-nav-bar.component.html",
  styleUrl: "./popup-minimized-nav-bar.component.scss",
})
export class PopupMinimizedNavBarComponent {
  public readonly subItems = input<SubItemMenu[]>();
  public readonly navBarService = inject(NavBarService);
  public readonly titleSubItems = input.required<string>();

  protected onMouseOver(): void {
    this.navBarService.closeAllPopups();
  }
}
